import React from "react";
import { useAuth } from "../../auth/useAuth.js";

const labels = [
  { key: "prebid", label: "Online bidding (prebid)" },
  { key: "liveBid", label: "Live bidding" },
  { key: "copart", label: "Copart (US)" },
  { key: "copartCanada", label: "Copart Canada" },
  { key: "iaai", label: "IAAI (US)" },
  { key: "iaaiCanada", label: "IAAI Canada" },
  { key: "manheim", label: "Manheim" },
  { key: "happycarservice", label: "Happycarservice" },
  { key: "windmotors", label: "Windmotors" },
];

export default function Statuses() {
  const { user } = useAuth();
  const statuses = user?.statuses ?? {};

  return (
    <div className="card">
      <div className="card__title">Statuses</div>
      <div className="grid grid-3">
        {labels.map(({ key, label }) => {
          const val = statuses[key] ?? "Inactive";
          const isActive = val === "Active";
          return (
            <div key={key} className="data-row">
              <span className="small">{label}</span>
              <span className={`badge ${isActive ? "active" : "inactive"}`}>{val}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
